var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 49.5C97.3 43.2 95.6 38.2 94.3 35.2C90.6 26.6 83.7 19.7 75 16C75 16 74.9 15.9 74.8 15.9C58.8 8.7 41.5 13.5 31.7 25.8C26.1 32.4 22.7 40.9 22.8 50.3C22.8 55.5 23.9 60.4 25.8 64.8C25.9 65 25.9 65.2 26 65.4C27.8 69.7 30.1 72.6 31.8 74.4C34.5 77.5 37.7 80.2 41.3 82.2C48.4 86.7 56.2 88.3 64.7 87C70.2 86.3 75.4 84.5 79.9 81.6C86.1 77.9 90.8 72.6 93.8 65.9C96.1 61 97.4 55.4 97.3 49.5C97.3 49.6 97.3 49.6 97.3 49.5Z",
    fill: "#5A87FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 49.5C97.3 43.2 95.6 38.2 94.3 35.2C90.6 26.6 83.7 19.7 75 16C75 16 74.9 15.9 74.8 15.9C58.8 8.7 41.5 13.5 31.7 25.8C26.1 32.4 22.7 40.9 22.8 50.3C22.8 55.5 23.9 60.4 25.8 64.8C25.9 65 25.9 65.2 26 65.4C27.8 69.7 30.1 72.6 31.8 74.4C34.5 77.5 37.7 80.2 41.3 82.2C48.4 86.7 56.2 88.3 64.7 87C70.2 86.3 75.4 84.5 79.9 81.6C86.1 77.9 90.8 72.6 93.8 65.9C96.1 61 97.4 55.4 97.3 49.5ZM97.3 49.5C97.3 49.6 97.3 49.6 97.3 49.5Z",
    stroke: "#5A87FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4 35.6C92.7 31.6 88.7 24.1 81.3 19.4C80.2 18.7 79.2 18 78.1 17.4C75.5 15.9 73 14.6 70.4 17.3C67.8 20 69.3 22.6 70.8 25.1C72.1 27.2 73.9 29.1 75 31.3C76.2 33.6 76.3 36.4 74.8 38.5C73.2 40.6 71.2 38.8 69.3 38.1C63.3 36 57.6 36.6 53 41.2C48.7 45.5 49.9 50.9 55.4 53.4C58.7 54.9 60.9 57.2 61.3 60.9C61.6 63.6 62 66.2 62.6 68.8C63.2 71.8 63.9 74.9 67.8 75.3C71.5 75.7 73.3 73.1 74.5 70.3C77.6 62.9 79.3 55.2 77.6 47.3C76.8 43.6 78 42.7 81.4 43.1C82.8 43.3 86.2 43.4 89.2 43.2C95.4 43.3 96.9 41.2 94.4 35.6Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 44.9C47.7 51.7 39.2 57.9 34.8 51C33.8 49.2 33.7 47 34.4 45.2C34.3 47.1 34.7 49 35.7 50.3C40 55.7 45.9 50.2 46.1 44.9Z",
    fill: "#101C1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 44.5C72.8 51.3 64.7 57.3 59.9 50.8C58.8 48.9 58.7 46.6 59.5 44.8H59.6C59.6 46.7 60 48.6 61.1 49.9C62.1 51.2 63.6 52.3 65.4 52.3C69 52.2 71.7 48 71.6 44.5C71.7 44.5 71.8 44.5 71.8 44.5Z",
    fill: "#101C1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2 65.2C57.2 72 45.9 73.9 43.7 67L43.8 66.9C46.8 69.8 51.8 71.2 55.4 68.6C56.6 67.8 57.5 66.5 58 65.1L58.2 65.2Z",
    fill: "#101C1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36.7C9.99998 34.3 0.0999851 26.7 2.59999 21.4C5.49999 17.4 10.4 18.3 12.7 22.4L12 22.6C11.8 19.6 13.9 16.4 17.1 15.8C19.6 15.2 22.2 17.1 22.7 19.5C23.4 23.3 21.1 26.9 19.3 29.9C17.7 32.3 16 34.5 14 36.6C16.3 33.1 18.6 29.5 20.2 25.6C20.9 23.8 21.6 21.8 21.3 19.9C20.4 16.4 16.3 16.4 14.2 19C12.9 20.4 12.7 22.3 12.8 24.1L12.2 22.7C10.5 18.7 5.89998 17.8 3.59999 21.8C2.59999 24.7 6.89999 28.9 8.69999 31.1C10.5 33 12.3 34.8 14.2 36.6L14 36.7Z",
    fill: "#FEDC5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.9C37 31 36.6 29.2 36 26.8C35.2 24 34 23 31.8 25.8C23.8 35.7 20.8 46.7 24 59.2C24.7 62.9 26.3 66.1 28.1 69.3C28.5 70 28.8 71 29.8 70.9C31 70.8 31.2 69.5 31.4 68.6C32 65.1 30.3 62.1 29.1 59C26.6 52.6 27.1 46.7 31.2 41C33.1 38.5 34.5 35.7 36 32.9Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveImpact);
export default __webpack_public_path__ + "static/media/positive-impact.80dc52423b0ab4d35544e5b7371976c0.svg";
export { ForwardRef as ReactComponent };